import React, { useState, useEffect } from "react"
import { Button, HStack, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react"
import axios from "axios"
import { EXPORT_LIBRARY_ENDPOINT } from "apps/simplified-web/src/_actions/endpoints"

const StudioDownloadQueueSidebar = (props) => {
  const { } = props

  useEffect(() => {
    fetchExportLibrary()
  }, [])

  return (
    <>
      <Tabs isFitted>
        <TabList>
          <Tab>Publish</Tab>
          <Tab>Download</Tab>
        </TabList>

        <HStack
          justify="space-between"
          my="4"
        >
          <Button>
            Cancel All
          </Button>
          <Button>
            Clear Finished
          </Button>
        </HStack>

        <TabPanels>
          <TabPanel>
          </TabPanel>
          <TabPanel>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  )

  function fetchExportLibrary() {
    axios
      .get(EXPORT_LIBRARY_ENDPOINT)
      .then((res) => {
        console.log(res.data.results);
      })
  }
}

export default StudioDownloadQueueSidebar